import { RoleName } from '@/api/entities/user-role-type';
import { useTranslation } from 'react-i18next';
import { useAuth, useUserRole } from '@/hooks/auth.hooks';
import { useGetLegalInformation } from '@/hooks/group.hooks';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation('common');
  const { isAdmin } = useUserRole();
  const { loggedInUser } = useAuth();

  const { data } = useGetLegalInformation(loggedInUser?.id, isAdmin ? RoleName.ADMIN : 'NOTADMIN');

  return (
    <div>
      <h1 className="text-3xl mb-4 text-center text-primary">{t('privacyPolicy')}</h1>
      <div  className="bg-white shadow-md rounded-lg p-10 text-justify" dangerouslySetInnerHTML={{ __html: data?.data?.privacyPolicy || '' }} />
    </div>
  );
}

export default PrivacyPolicyPage;